import React from 'react';

import { DateTimeDisplay } from './DateTimeDisplay';
import { RowWrapper, Vr } from './FlightSummary';
import { TimeRowData } from './flightDataUtils';

interface DateTimeRowProps {
  dateTimeRowData: TimeRowData;
}

/**
 * DateTimeRow component to display a row of date-time data.
 * @param {DateTimeRowProps} props - The props for the component.
 * @returns {JSX.Element} The DateTimeRow component.
 */
export const DateTimeRow: React.FC<DateTimeRowProps> = ({ dateTimeRowData }) => {
  return (
    <RowWrapper>
      <DateTimeDisplay dateTimeData={dateTimeRowData?.scheduled} />
      <Vr />
      <DateTimeDisplay dateTimeData={dateTimeRowData?.second} />
    </RowWrapper>
  );
};